"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const OrderView_1 = require("./OrderTemp/views/OrderView");
const ORDER_DETAILS_SELECT = {
    createdAt: true,
    status: true,
    number: true,
    phone: true,
    email: true,
    total: true,
    undiscountedTotal: true,
    paymentMethod: true,
    shippingAddress: {
        firstName: true,
        lastName: true,
        city: true,
        postalCode: true,
        address: true,
        address2: true,
    },
    shipping: {
        price: {
            amount: true,
            taxRate: true,
            taxSymbol: true,
            currency: true,
        },
        title: true,
    },
};
const ORDER_PRODUCT_SELECT = {
    id: true,
    quantity: true,
    product: {
        id: true,
        title: true,
        price: {
            amount: true,
            taxRate: true,
            taxSymbol: true,
            currency: true,
        },
        regularPrice: {
            amount: true,
            taxRate: true,
            taxSymbol: true,
            currency: true,
        },
        lowestPriceBeforeSale: {
            amount: true,
            taxRate: true,
            taxSymbol: true,
            currency: true,
        },
    },
    storeVariant: {
        attributes: {
            value: true,
        },
    },
};
const ORDER_VOUCHER_SELECT = {
    id: true,
    value: true,
    currency: true,
    physical: true,
    dedication: true,
    serviceId: true,
};
function Order({ id, logo, mail }) {
    const { data, loading: detailsLoading } = (0, app_1.useQuery)('getOrderDetails', {
        args: {
            id,
        },
        select: ORDER_DETAILS_SELECT,
    });
    const { data: products, loading: productsLoading } = (0, app_1.useQuery)('getOrderProducts', {
        args: {
            id,
        },
        select: ORDER_PRODUCT_SELECT,
    });
    const { data: vouchers, loading: vouchersLoading } = (0, app_1.useQuery)('getOrderVouchers', {
        args: {
            id,
        },
        select: ORDER_VOUCHER_SELECT,
    });
    const authenticated = Boolean(data === null || data === void 0 ? void 0 : data.number);
    const allLoading = productsLoading || detailsLoading || vouchersLoading;
    const fullData = allLoading || !data
        ? undefined
        : Object.assign(Object.assign({}, data), { products: products !== null && products !== void 0 ? products : [], vouchers: (vouchers !== null && vouchers !== void 0 ? vouchers : []).map((v) => (Object.assign(Object.assign({}, v), { quantity: 1 }))) });
    return ((0, jsx_runtime_1.jsx)(app_1.Context, Object.assign({ name: "checkout", render: "div" }, { children: (0, jsx_runtime_1.jsx)(OrderView_1.OrderView, { authenticated: authenticated, data: fullData, loading: allLoading, logo: logo, mail: mail, id: id }) })));
}
exports.Order = Order;
